module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"departure-date":"Date de départ","return-date":"Date de retour","errors":{"departure-date-required":"La date de départ est requise","return-date-required":"La date de retour est requise"}},"en":{"departure-date":"Departure date","return-date":"Return date","errors":{"departure-date-required":"Departure date is required","return-date-required":"Return date is required"}}}')
  delete Component.options._Ctor
}
